import ResetPassword from "@/modules/ResetPassword/pages/ResetPassword";

export default [
  {
    path: "/reset-password/:mailtoken",
    component: ResetPassword,
    meta: { title: "Reset Password" },
  },
];
